'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _swipeJsIso = require('swipe-js-iso');

var _swipeJsIso2 = _interopRequireDefault(_swipeJsIso);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'carousel';

var Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel(props) {
    _classCallCheck(this, Carousel);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.state = {
      currentSlide: 0,
      autoPlay: props.children.length > 1 ? props.options.auto : 0,
      numSlides: props.children.length,
      isTransitioning: false,
      isLoading: true
    };

    _this.next = _this.next.bind(_this);

    _this.nextSlide = _this.nextSlide.bind(_this);
    _this.prevSlide = _this.prevSlide.bind(_this);

    _this.slideTo = _this.slideTo.bind(_this);
    _this.swiping = _this.swiping.bind(_this);
    _this.transitionEnd = _this.transitionEnd.bind(_this);

    _this.pauseSlide = _this.pauseSlide.bind(_this);
    _this.resumeSlide = _this.resumeSlide.bind(_this);
    _this.stopAutoPlay = _this.stopAutoPlay.bind(_this);

    _this.setTabIndex = _this.setTabIndex.bind(_this);

    _this.handleInitialLoad = _this.handleInitialLoad.bind(_this);
    return _this;
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleInitialLoad();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setTabIndex();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.swipe) this.swipe.kill();
      this.swipe = undefined;
      clearTimeout(this.timeout);
    }
  }, {
    key: 'setTabIndex',
    value: function setTabIndex() {
      var activeSlide = '[data-index="' + this.state.currentSlide + '"]';
      var inactiveSlides = '.carousel__wrapper > :not([data-index="' + this.state.currentSlide + '"])';
      var tabableElements = 'a, area, button, input, object, select, textarea';
      var inactiveSlidesArr = [].concat(_toConsumableArray(this.container.querySelectorAll(inactiveSlides)));
      var activeSlidesArr = this.container.querySelectorAll(activeSlide);

      inactiveSlidesArr.forEach(function (e) {
        var inactiveElementsArr = [].concat(_toConsumableArray(e.querySelectorAll(tabableElements)));

        inactiveElementsArr.forEach(function (el) {
          var element = el;
          element.tabIndex = '-1';
        });
      });

      if (activeSlidesArr.length) {
        var activeElementsArr = [].concat(_toConsumableArray(activeSlidesArr[0].querySelectorAll(tabableElements)));
        activeElementsArr.forEach(function (el) {
          var element = el;
          element.tabIndex = '0';
        });
      }
    }
  }, {
    key: 'getNumSlides',
    value: function getNumSlides() {
      return this.swipe.getNumSlides();
    }
  }, {
    key: 'getPos',
    value: function getPos() {
      return this.swipe.getPos();
    }
  }, {
    key: 'setPos',
    value: function setPos() {
      this.setState({
        currentSlide: this.getPos()
      });
    }
  }, {
    key: 'initCarousel',
    value: function initCarousel() {
      var options = this.props.options;

      var self = this;

      Object.assign(options, {
        transitionEnd: self.transitionEnd,
        swiping: self.swiping,
        auto: 0
      });

      this.swipe = new _swipeJsIso2.default(this.container, options);
      this.resume();
    }
  }, {
    key: 'handleInitialLoad',
    value: function handleInitialLoad() {
      this.setState({ isLoading: false }, this.initCarousel);
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.swipe) this.swipe.stop();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (!this.play) {
        this.play = true;
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'swiping',
    value: function swiping() {
      this.stopAutoPlay();
    }
  }, {
    key: 'resume',
    value: function resume() {
      var autoPlay = this.state.autoPlay;

      if (!this.play && autoPlay) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.next, autoPlay);
      }
    }
  }, {
    key: 'pauseSlide',
    value: function pauseSlide() {
      this.stop();
      this.pause();
    }
  }, {
    key: 'resumeSlide',
    value: function resumeSlide() {
      this.setState({
        autoPlay: this.props.options.auto
      });
      this.play = false;
      this.resume();
    }
  }, {
    key: 'stopAutoPlay',
    value: function stopAutoPlay() {
      if (this.state.autoPlay) {
        this.setState({
          autoPlay: 0
        });
        this.setPos();
      }
    }
  }, {
    key: 'slideTo',
    value: function slideTo() {
      var _swipe;

      this.stopAutoPlay();
      (_swipe = this.swipe).slide.apply(_swipe, arguments);
    }
  }, {
    key: 'next',
    value: function next() {
      var currentSlide = this.state.currentSlide;

      var numSlides = this.getNumSlides();
      if (currentSlide + 1 === numSlides) {
        this.swipe.slide(0);
      } else {
        this.swipe.next();
      }
      this.setPos();
    }
  }, {
    key: 'prev',
    value: function prev() {
      this.swipe.prev();
      this.setPos();
    }
  }, {
    key: 'prevSlide',
    value: function prevSlide(e) {
      e.preventDefault();
      if (this.state.currentSlide === 0) {
        return;
      }
      this.stopAutoPlay();
      this.prev();
    }
  }, {
    key: 'nextSlide',
    value: function nextSlide(e) {
      e.preventDefault();
      if (this.state.currentSlide + 1 >= this.state.numSlides) {
        return;
      }
      this.stopAutoPlay();
      this.next();
    }
  }, {
    key: 'transitionEnd',
    value: function transitionEnd(index, el) {
      var numSlides = this.getNumSlides();
      if (this.props.callback) this.props.callback(index, el);
      this.setState({
        currentSlide: index >= numSlides ? index - numSlides : index,
        isTransitioning: false
      });

      if (!this.play && this.state.autoPlay) {
        this.stop();
        this.resume();
      }

      this.setState({ isTransitioning: false });
    }
  }, {
    key: 'renderDotSelectors',
    value: function renderDotSelectors(itemsLen) {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          trackId = _props.trackId,
          content = _props.content;
      var currentSlide = this.state.currentSlide;

      var activeSlide = currentSlide >= itemsLen ? 0 : currentSlide;
      var items = [];
      var listStyle = {
        display: 'inline-block',
        lineHeight: 0
      };

      var _loop = function _loop(i) {
        var _cx;

        var isActive = activeSlide === i;
        var selectorClass = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, ORGANISM_NAME + '__dot-selector__button', true), _defineProperty(_cx, ORGANISM_NAME + '__dot-selector__button--active', isActive), _defineProperty(_cx, ORGANISM_NAME + '__dot-selector__button--transitioning', _this2.state.isTransitioning), _defineProperty(_cx, className + '__dot-selector__button', className), _defineProperty(_cx, className + '__dot-selector__button--active', className && isActive), _cx));

        items.push(_react2.default.createElement(
          'li',
          {
            className: className + '__dot-selector__li',
            key: trackId + '-DotSelector-' + i,
            style: listStyle
          },
          _react2.default.createElement('button', {
            'aria-label': content.goToSlide.text + ' ' + i,
            className: selectorClass,
            onClick: function onClick() {
              _this2.slideTo(i);_this2.setState({ isTransitioning: true });
            },
            'data-pa-click': trackId + '-DotSelector-Slide' + i,
            id: trackId + '-DotSelector-' + i,
            tabIndex: isActive ? -1 : 0
          })
        ));
      };

      for (var i = 0; i < itemsLen; i += 1) {
        _loop(i);
      }

      return _react2.default.createElement(
        'ul',
        {
          onMouseEnter: this.pauseSlide,
          onMouseLeave: this.resumeSlide,
          className: className + '__dot-selector ' + ORGANISM_NAME + '__dot-selector'
        },
        items
      );
    }
  }, {
    key: 'renderSlideCounter',
    value: function renderSlideCounter(itemsLen) {
      var className = this.props.className;
      var currentSlide = this.state.currentSlide;

      var activeSlide = currentSlide >= itemsLen ? 1 : currentSlide + 1;

      return _react2.default.createElement(
        'span',
        {
          className: className + '__slide-counter ' + ORGANISM_NAME + '__slide-counter'
        },
        activeSlide + ' / ' + itemsLen
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx2,
          _cx3,
          _this3 = this;

      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          styles = _props2.styles,
          trackId = _props2.trackId,
          content = _props2.content;

      var leftClass = (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, ORGANISM_NAME + '__arrow', true), _defineProperty(_cx2, ORGANISM_NAME + '__arrow__left', true), _defineProperty(_cx2, ORGANISM_NAME + '__arrow__left--disabled', this.state.currentSlide === 0), _defineProperty(_cx2, className + '__arrow', className), _defineProperty(_cx2, className + '__arrow__left', className), _defineProperty(_cx2, className + '__arrow__left--disabled', className && this.state.currentSlide === 0), _cx2));

      var rightClass = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, ORGANISM_NAME + '__arrow', true), _defineProperty(_cx3, ORGANISM_NAME + '__arrow__right', true), _defineProperty(_cx3, ORGANISM_NAME + '__arrow__right--disabled', this.state.currentSlide + 1 >= this.state.numSlides), _defineProperty(_cx3, className + '__arrow', className), _defineProperty(_cx3, className + '__arrow__right', className), _defineProperty(_cx3, className + '__arrow__right--disabled', className && this.state.currentSlide + 1 >= this.state.numSlides), _cx3));

      var children = _react2.default.Children.map(this.props.children, function (child) {
        var element = _react2.default.cloneElement(child, { style: styles.child });
        return element;
      });

      var wrapperClasses = (0, _classnames2.default)(_defineProperty({}, ORGANISM_NAME + '__wrapper--no-js', this.state.isLoading), ORGANISM_NAME + '__wrapper', className + '__wrapper');

      return _react2.default.createElement(
        'div',
        {
          className: ORGANISM_NAME + ' ' + className
        },
        _react2.default.createElement(
          'div',
          {
            ref: function ref(element) {
              _this3.container = element;
            },
            id: id,
            style: styles.container,
            onMouseEnter: this.pauseSlide,
            onMouseLeave: this.resumeSlide,
            onClick: this.stopAutoPlay,
            role: 'button',
            tabIndex: '-1',
            onKeyUp: function onKeyUp() {}
          },
          _react2.default.createElement(
            'div',
            { className: wrapperClasses, style: styles.wrapper },
            this.state.isLoading ? children[0] : children
          )
        ),
        this.props.children.length > 1 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('button', {
            'aria-label': content.goToNextSlide.text,
            className: rightClass,
            onClick: this.nextSlide,
            'data-pa-click': trackId + '-RtArrow-Slide' + this.state.currentSlide,
            tabIndex: this.state.currentSlide + 1 >= this.state.numSlides ? -1 : 0,
            id: trackId + '-RtArrow-' + this.state.currentSlide
          }),
          _react2.default.createElement('button', {
            'aria-label': content.goToPreviousSlide.text,
            className: leftClass,
            onClick: this.prevSlide,
            'data-pa-click': trackId + '-LftArrow-Slide' + this.state.currentSlide,
            id: trackId + '-LftArrow-' + this.state.currentSlide,
            tabIndex: this.state.currentSlide === 0 ? -1 : 0
          })
        ),
        this.props.children.length > 1 && (this.props.renderNumberCounter || this.props.children.length > this.props.numberCounterThreshold ? this.renderSlideCounter(this.props.children.length) : this.renderDotSelectors(this.props.children.length))
      );
    }
  }]);

  return Carousel;
}(_react2.default.Component);

exports.default = Carousel;


Carousel.propTypes = {
  id: _propTypes2.default.string,
  options: _propTypes2.default.shape({
    startSlide: _propTypes2.default.number,
    speed: _propTypes2.default.number,
    auto: _propTypes2.default.number,
    continuous: _propTypes2.default.bool,
    disableScroll: _propTypes2.default.bool,
    stopPropagation: _propTypes2.default.bool,
    swiping: _propTypes2.default.func,
    callback: _propTypes2.default.func,
    transitionEnd: _propTypes2.default.func
  }),
  styles: _propTypes2.default.shape({
    container: _propTypes2.default.object,
    wrapper: _propTypes2.default.object,
    child: _propTypes2.default.object
  }),
  content: _propTypes2.default.shape({
    goToSlide: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    goToNextSlide: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    goToPreviousSlide: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  callback: _propTypes2.default.func,
  className: _propTypes2.default.string.isRequired,
  trackId: _propTypes2.default.string.isRequired,
  numberCounterThreshold: _propTypes2.default.number,
  renderNumberCounter: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired
};

Carousel.defaultProps = {
  id: '0',
  options: {
    startSlide: 0,
    speed: 400,
    continuous: false
  },
  styles: {
    container: {
      overflow: 'hidden',
      position: 'relative'
    },
    wrapper: {
      overflow: 'hidden',
      position: 'relative'
    },
    child: {
      float: 'left',
      width: '100%',
      position: 'relative',
      transitionProperty: 'transform'
    }
  },
  content: {
    goToSlide: {
      text: 'Go to slide'
    },
    goToNextSlide: {
      text: 'Go to next slide'
    },
    goToPreviousSlide: {
      text: 'Go to previous slide'
    }
  },
  callback: function callback() {},
  numberCounterThreshold: 6,
  renderNumberCounter: false
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/carousel/main/jsx/Carousel.js
// module id = 432
// module chunks = 4